import React from "react";
import {Breadcrumb} from "flowbite-react";
import {HiHome} from "react-icons/hi";
import {Link, Outlet} from "react-router-dom";

const Doc = () => {
    return (
        <section className="bg-white dark:bg-gray-700">
            <Breadcrumb aria-label="Breadcrumb navigation" className="bg-gray-100 px-5 py-3 dark:bg-gray-900">
                <Breadcrumb.Item href="/" icon={HiHome}>Home</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span className="text-gray-900 dark:text-white">Documentation</span>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div className="mx-auto max-w-screen-md text-center my-8">
                <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
                    Documentation
                </h1>
                <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
                    Explore the complete documentation below
                </p>
            </div>

            <div className="mx-auto max-w-screen-lg pb-8">
                <ul className="space-y-4 text-lg">
                    {[
                        { to: "extra-features", label: "Extra Features", description: "Discover how extra features can enhance your forms" },
                        { to: "telegram-bot-doc", label: "Telegram Bot Guide", description: "Step-by-step instructions on integrating and utilizing our Telegram bot" },
                        { to: "important-notes", label: "Important Notes", description: "Key considerations and important notes to keep in mind when using our system" }
                    ].map((item, index) => (
                        <li key={index}>
                            <Link to={item.to} className="text-blue-600 hover:underline dark:text-blue-400">
                                {item.label}
                            </Link>
                            <p className="text-sm text-gray-600 dark:text-gray-300">{item.description}</p>
                        </li>
                    ))}
                </ul>

                <div className="mt-8 space-y-6 text-lg text-gray-700 dark:text-gray-300 text-justify">
                    <p>
                        Welcome to the official documentation. Here, you’ll find detailed guides, explanations, and
                        references to help you navigate through various features and functionalities of our system.
                        Whether you're a beginner or an advanced user, this documentation is designed to assist you
                        in understanding how everything works.
                    </p>
                    <p>
                        Throughout the documentation, you will also find best practices, security recommendations, and
                        optimization techniques that will help you enhance your implementation. We aim to provide a
                        seamless experience so that you can focus on building great solutions with confidence. Each
                        section contains useful insights, practical examples, and troubleshooting tips to ensure
                        a smooth experience. We encourage you to explore each topic in detail and leverage the
                        provided resources to enhance your understanding.
                    </p>
                    <p>
                        If you have any questions, feel free to reach out to our support team or check the community
                        discussions for additional help. Your feedback is valuable in improving our system, so
                        don’t hesitate to share your thoughts with us.
                    </p>
                    <p>
                        If you have any questions, feel free to reach out to our support team or check the community
                        discussions for additional help. Your feedback is valuable in improving our documentation, so
                        don’t hesitate to share your thoughts with us.
                    </p>
                    <p>
                        Stay updated with the latest features and improvements by following this page and our
                        announcements.
                    </p>
                </div>

                <Outlet />
            </div>
        </section>
    );
};

export default Doc;